<template>
  <v-content style="padding-top: 0">
    <div v-if="$route.name !== 'Login' && $route.name !== 'Learning Management'">

      <core-toolbar />
      <core-drawer />
    </div>

    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'BacBon School | Admin'
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
